import { useContext } from 'react'

import { DynamicIslandRowsContext } from './DynamicIslandProvider'

export const useDynamicIsland = () => {
  return useContext(DynamicIslandRowsContext)
}
